<template>
  <div class='container'>
    <h1>{{ $t('title') }}</h1>
    <div class='row'>
      <div class='col-xs-12'>
        <div :class="{ 'pre-scrollable': showButtons }">
          <template v-if="$i18n.locale === 'en'">
            <ol>
              <li>
                <strong>General </strong>
                <ol>
                  <li>All products and services provided by GS1 Germany (hereinafter referred to as the “Provider”) in
                    the context of Customer’s use of the Verified by GS1 application shall be made available solely on
                    the basis of the following Terms of Use as last amended at the time of use. Unless otherwise agreed
                    explicitly in writing, no deviating terms and conditions shall apply.
                  </li>
                  <li>Customers in the context of these Terms of Use are exclusively operators. Within the meaning of
                    the Terms of Use, these are natural or legal persons or partnerships with legal capacity who/which
                    are exercising their commercial or independent professional activity at the time the Contract with
                    the Provider is concluded.
                  </li>
                </ol>
              </li>
              <li>
                <strong>Subject of the Contract</strong>
                <ol>
                  <li>The subject of the Contract is the provision of the application as an online version using a
                    current and customary internet browser or an API.
                  </li>
                  <li>The application may be made available by the Provider free of charge or subject to the payment of
                    a fee. If using the application free of charge, the User shall not be entitled to expect the
                    continued provision of individual functions of the application.
                  </li>
                  <li>The Provider does not guarantee that the application will function error-free on all browsers. The
                    application will only be optimised for the most commonly used browsers.
                  </li>
                  <li>The use of the application requires the transfer of data via the internet. The User is responsible
                    for this and shall bear any associated costs.
                  </li>
                  <li>The Provider is entitled to use open source components within the application, to the extent that
                    they do not impair the normal use of the application by the User in accordance with this Contract.
                  </li>
                </ol>
              </li>
              <li>
                <strong>Conclusion of the Contract and user account</strong>
                <ol>
                  <li>The use of the application results in a contract for use between the User and the Provider in
                    respect of the use of the application. If the User registers in the application, this shall result
                    in a contractual relationship between the Provider and the User.
                  </li>
                  <li>The condition for using the application is that the User registers by creating a user account in
                    which their data are stored permanently. The registration consists of a user name and a password
                    (“Login Data”). A user account can only be created if the User provides a current email address.
                    This email address will also be used for communication with the Provider. There is no specific
                    entitlement to being granted access to use the application.
                  </li>
                  <li>The User is obliged to treat their Login Data with care. In particular, the User shall not share
                    their Login Data with third parties and/or enable third parties to access their profile by
                    circumventing the need for Login Data.
                  </li>
                  <li>Should the User breach their obligations as set forth above and their user account be used by
                    third parties, the User shall be liable for all activities performed with their user account. The
                    User shall not be liable if they were not responsible for the misuse of their account.
                  </li>
                  <li>The User warrants that the data used to create their profile (“Profile Data”) are complete and
                    correct.
                  </li>
                </ol>
              </li>
              <li>
                <strong>Obligations of the User</strong>
                <ol>
                  <li>The User shall be responsible for the security of their own data. The Provider assumes no
                    liability for the loss of the data saved permanently by the User in the application.
                  </li>
                  <li>Regarding the extent of the use of data, the GS1 Registry conditions of participation for data
                    recipients shall apply. These can be viewed at <a
                      href='https://www.gs1-germany.de/fileadmin/gs1/agb/GS1_Registry_Teilnahmebedingungen_fuer_Datenempfaenger.pdf'>GS1
                      Registry Teilnahmebedingungen</a>.
                  </li>
                  <li>In the event of any malfunction of the application and/or its functionalities, the User shall
                    notify the Provider of such malfunction by email without undue delay. The same shall apply if the
                    User receives information about content published by third parties that evidently breaches
                    applicable law or third-party rights.
                  </li>
                </ol>
              </li>
              <li>
                <strong>Rights of use</strong>
                <ol>
                  <li>The application and the content provided therein are protected by copyright. The Provider holds
                    all rights.
                  </li>
                  <li>The User shall receive a simple and non-transferable right that is restricted to the term of this
                    Contract and allows use of the application in accordance with the terms and conditions.
                  </li>
                  <li>The User shall not be entitled to any further uses. In particular, the User shall be prohibited
                    from selling, renting, loaning or reproducing the application’s content, the application itself or
                    parts thereof or from distributing its content and/or publishing this in any other way. The
                    distribution and/or reproduction of any of the application’s content without the Provider’s consent
                    are prohibited.
                  </li>
                  <li>The User shall grant the Provider rights to use the data provided in the application that are
                    necessary to execute the Contract. These include but are not restricted to the right to give access
                    to the data via the internet in response to queries and especially to reproduce and transmit these
                    data as well as to reproduce the data for the purposes of data security.
                  </li>
                </ol>
              </li>
              <li>
                <strong>Fee</strong><br>
                After successful registration, you can use Verified by GS1 without restrictions during a free trial period. We reserve the right to offer the service for a fee in the future. We will inform you of any changes in due course.
              </li>
              <li>
                <strong>Availability</strong>
                <ol>
                  <li>Adjustments, amendments and additions to the contractual services as well as measures to identify
                    and remedy any malfunctions shall only result in a temporary interruption to or impairment of
                    accessibility if this is essential for technical reasons.
                  </li>
                  <li>The Provider aims to ensure average annual availability of the application of 98.5%. Planned and
                    communicated maintenance work shall not be deemed failure time. The Provider shall endeavour to
                    communicate maintenance work at least seven (7) days in advance.
                  </li>
                </ol>
              </li>
              <li>
                <strong>Force majeure</strong>
                <ol>
                  <li>The Provider shall be released from its obligation to execute this Contract if the non-performance
                    of services is due to the occurrence of force majeure after conclusion of the Contract.
                  </li>
                  <li>Such force majeure shall include, for example, war, strikes, unrest, pandemics, expropriations,
                    substantial changes in law, storms, floods and other natural catastrophes as well as any other
                    circumstances for which the Provider shall not be held responsible, especially the ingress of water,
                    power cuts, disruption to or destruction of data lines or infrastructure and hacker attacks that
                    could not have been prevented even by taking security measures that are customary for the industry.
                  </li>
                  <li>Each Party shall notify the other Party in writing and without undue delay of the occurrence of
                    force majeure.
                  </li>
                </ol>
              </li>
              <li>
                <strong>Limitation of liability</strong>
                <ol>
                  <li>The Provider shall be liable without limitation for wilful intent or gross negligence. However, in
                    the case of slight negligence, it shall be liable only for any breach of material contractual
                    obligations. These shall include those obligations that are necessary for the proper execution of
                    the Contract, compliance with which is and may be relied upon by the Parties. Liability in the event
                    of a breach of such material contractual obligations shall be limited to damages typical for such
                    contracts, the occurrence of which the Provider must anticipate upon conclusion of the Contract on
                    the basis of the circumstances known at that time.
                  </li>
                  <li>The aforementioned exclusion of liability shall not apply to injuries to life, limb or health.
                    Liability in accordance with product liability legislation shall not be affected.
                  </li>
                  <li>The Provider assumes no liability for any network faults for which it is not responsible.</li>
                  <li>In the event of a loss of data, the Provider shall only be liable as set forth above if such loss
                    of data would not have been avoidable had the User taken appropriate data security measures.
                  </li>
                  <li>The Provider shall not be liable for impairments caused by improper or incorrect use by the
                    User.
                  </li>
                  <li>The limitations of liability set forth above shall also apply mutatis mutandi to the Provider’s
                    agents.
                  </li>
                  <li>If the application provides the option of redirection to third-party databases, websites,
                    interfaces or services, e.g. by the provision of links or hyperlinks, the Provider shall not be
                    liable for the accessibility, continued existence or security of these databases or services nor for
                    their content. In particular, the Provider shall not be liable for their legality or for the
                    accuracy, completeness or validity of their content.
                  </li>
                </ol>
              </li>
              <li>
                <strong>Data protection</strong><br>
                The User may find information about the processing of personal data in the Provider’s privacy policy.
                This can be accessed at <a href='https://www.gs1-germany.de/datenschutz/'>Datenschutzinformationen</a>.
              </li>
              <li>
                <strong>Term of the Contract, notice of termination</strong>
                <ol>
                  <li>The term of the Contract and the notice periods are defined in the respective product description
                    which can be accessed at <a
                      href='https://www.gs1-germany.de/fileadmin/gs1/agb/GS1_Germany_Leistungsbeschreibung_VbGS1_.pdf'>Produktbeschreibung</a>.
                  </li>
                  <li>Upon termination of the Contract, the User shall have no further access to the services covered by
                    this Contract.
                  </li>
                  <li>
                    This shall not affect the rights of the Parties of extraordinary termination for cause which shall
                    exist especially if:
                    <ul>
                      <li>a Party repeatedly breaches material contractual obligations, despite a formal warning to
                        desist;
                      </li>
                      <li>a Party acts illegally in connection with this Contract;</li>
                      <li>one of the Parties ceases operation in whole or in part and its continued operation is not
                        guaranteed by a direct legal successor.
                      </li>
                    </ul>
                  </li>
                  <li>The notice of termination must be made in writing. An email is sufficient.</li>
                  <li>Upon termination of the Contract, irrespective of the reason, the User’s contractual rights of use
                    shall end.
                  </li>
                </ol>
              </li>
              <li>
                <strong>Miscellaneous, final provisions</strong>
                <ol>
                  <li>The law of the Federal Republic of Germany shall apply. The exclusive jurisdiction for disputes
                    arising from this Contract shall be Cologne, Germany.
                  </li>
                  <li>The Contract language is German. Should translations of the Contract contradict the German
                    version, the latter shall have precedence.
                  </li>
                  <li>No oral side agreements have been made. Amendments to this Contract shall only be valid if
                    agreed by the Parties in writing. This shall also apply to any amendment of the written form
                    requirement.
                  </li>
                  <li>Should a provision of this Contract be or become invalid, this shall not affect the validity of
                    the remaining provisions of the Contract.
                  </li>
                  <li>The User waives compliance with the obligations in respect of e-commerce pursuant to Section
                    312i (1) sentence 1 No. 1 to 3 and sentence 2 of the German Commercial Code (BGB).
                  </li>
                </ol>
              </li>
            </ol>
          </template>
          <template v-else>
            <ol>
              <li>
                <strong>Allgemeines</strong>
                <ol>
                  <li>Sämtliche Lieferungen und Leistungen von GS1 Germany (nachfolgend „Anbieter“), die dem Kunden im
                    Rahmen der Anwendung „Verified by GS1“ zur Verfügung gestellt werden, erfolgen ausschließlich auf
                    der Grundlage der nachfolgenden Nutzungsbedingungen in ihrer zum Zeitpunkt der Nutzung gültigen
                    Fassung. Sofern nicht ausdrücklich schriftlich vereinbart, finden abweichende Geschäftsbedingungen
                    keine Anwendung.
                  </li>
                  <li>Kunde im Sinne dieser Geschäftsbedingungen sind ausschließlich Unternehmer. Im Sinne der
                    Geschäftsbedingungen sind dies natürliche oder juristische Personen oder rechtsfähige
                    Personengesellschaften, die bei Vertragsschluss mit dem Anbieter in Ausübung ihrer gewerblichen oder
                    selbständigen beruflichen Tätigkeit handeln.
                  </li>
                </ol>
              </li>
              <li>
                <strong>Nutzungsgegenstand</strong>
                <ol>
                  <li>Vertragsgegenstand ist die Bereitstellung der Anwendung in der Webversion unter Verwendung eines
                    aktuellen und gängigen Internetbrowsers sowie per API.
                  </li>
                  <li>Die Bereitstellung der Anwendung durch den Anbieter kann auf kostenfreier oder kostenpflichtiger
                    Basis erfolgen. Bei kostenfreier Nutzung besteht kein Anspruch des Nutzers auf Aufrechterhaltung
                    einzelner Funktionalitäten der Anwendung.
                  </li>
                  <li>Der Anbieter gewährleistet nicht, dass die Anwendung auf jedem Browser fehlerfrei funktioniert.
                    Die Optimierung der Anwendung erfolgt lediglich für die gängigsten Browser.
                  </li>
                  <li>Die Nutzung der Anwendung erfordert eine Datenübertragung über das Internet, wobei der Nutzer für
                    diese verantwortlich ist und die hierfür entstehenden Kosten selbst trägt.
                  </li>
                  <li>Der Anbieter ist berechtigt, innerhalb der Anwendung Open Source Bestandteile zu verwenden, soweit
                    sie der gewöhnlichen Verwendung der Anwendung durch den Nutzer nach dieser Vereinbarung nicht
                    entgegenstehen.
                  </li>
                </ol>
              </li>
              <li>
                <strong>Vertragsschluss und Nutzerkonto</strong>
                <ol>
                  <li>Durch die Nutzung der Anwendung kommt ein Nutzungsvertrag zwischen dem Nutzer und dem Anbieter
                    über die Nutzung der Anwendung zustande. Registriert sich der Nutzer in der Anwendung, kommt
                    insoweit ein Vertragsverhältnis zwischen dem Anbieter und dem Nutzer zustande.
                  </li>
                  <li>Voraussetzung der Nutzung der Anwendung ist die Registrierung des Nutzers mit Erstellung eines
                    Nutzerkontos, in dem die Daten des Nutzers dauerhaft gespeichert werden. Die Registrierung besteht
                    aus einem Usernamen und einem Kennwort („Login-Daten“). Die Erstellung eines Nutzerkontos ist nur
                    unter Angabe einer aktuellen E-Mail-Adresse des Nutzers möglich. Diese E-Mail-Adresse dient zugleich
                    der Kommunikation mit dem Anbieter. Ein konkreter Anspruch auf Zulassung zur Nutzung der Anwendung
                    besteht nicht.
                  </li>
                  <li>Der Nutzer ist verpflichtet, mit den Login-Daten sorgfältig umzugehen. Insbesondere ist es dem
                    Nutzer untersagt, die Login-Daten Dritten mitzuteilen und/oder Dritten den Zugang zu dem Profil
                    unter Umgehung der Login-Daten zu ermöglichen.
                  </li>
                  <li>Wenn der Nutzer seine Verpflichtungen gemäß vorstehender Ziffer verletzt und sein Nutzerkonto von
                    Dritten verwendet wird, haftet der Nutzer für sämtliche Aktivitäten, die unter Verwendung seines
                    Nutzerkontos stattfinden. Der Nutzer haftet nicht, wenn er den Missbrauch seines Nutzerkontos nicht
                    zu vertreten hat.
                  </li>
                  <li>Der Nutzer sichert zu, dass die bei Erstellung seines Profils verwendeten Daten („Profil-Daten“)
                    vollständig und richtig sind.
                  </li>
                </ol>
              </li>
              <li>
                <strong>Pflichten des Nutzers</strong>
                <ol>
                  <li>Der Nutzer trägt für die Sicherung seiner Daten selbst Sorge. Der Anbieter übernimmt keine Gewähr
                    für den Verlust der dauerhaft durch den Nutzer innerhalb der Anwendung gespeicherten Daten.
                  </li>
                  <li>Für den Umfang der Datennutzung gelten die GS1 Registry Teilnahmebedingungen für Datenempfänger,
                    abrufbar unter <a
                      href='https://www.gs1-germany.de/fileadmin/gs1/agb/GS1_Registry_Teilnahmebedingungen_fuer_Datenempfaenger.pdf'>GS1
                      Registry Teilnahmebedingungen</a>.
                  </li>
                  <li>Sollte es bei der Nutzung der Anwendung bzw. ihrer Funktionalitäten zu Störungen kommen, wird der
                    Nutzer den Anbieter von dieser Störung unverzüglich per E-Mail in Kenntnis setzen. Gleiches gilt,
                    wenn der Nutzer Informationen über von Dritten veröffentlichte Inhalte erlangt, die offensichtlich
                    gegen geltendes Recht oder Rechte Dritter verstoßen.
                  </li>
                </ol>
              </li>
              <li>
                <strong>Nutzungsrechte</strong>
                <ol>
                  <li>Die Anwendung und die darin bereitgestellten Inhalte sind urheberrechtlich geschützt. Sämtliche
                    Rechte liegen beim Anbieter.
                  </li>
                  <li>Der Nutzer erhält das einfache, nicht übertragbare, auf die Laufzeit dieses Nutzungsvertrages
                    zeitlich beschränkte Recht, die Anwendung bestimmungsgemäß zu nutzen.
                  </li>
                  <li>Weitergehende Nutzungen sind dem Nutzer nicht gestattet. Es ist dem Nutzer insbesondere untersagt,
                    Inhalte aus der Anwendung, die Anwendung oder Teile davon zu vertreiben, zu vermieten, zu verleihen,
                    zu vervielfältigen oder ihre Inhalte zu verbreiten und/oder sonst zu veröffentlichen. Die
                    Verbreitung und/oder öffentliche Wiedergabe von jedweden Inhalten der Anwendung ohne Einwilligung
                    des Anbieters ist untersagt.
                  </li>
                  <li>Der Nutzer räumt dem Anbieter die zur Durchführung des Vertrages notwendigen Nutzungsrechte an den
                    Daten ein, die er in die Anwendung überträgt. Hierzu zählt insbesondere das Recht, die Daten bei
                    Abfragen über das Internet zugänglich machen zu dürfen und insbesondere sie hierzu vervielfältigen
                    und übermitteln sowie zum Zwecke der Datensicherung vervielfältigen zu dürfen.
                  </li>
                </ol>
              </li>
              <li>
                <strong>Vergütung</strong><br>
                Nach erfolgreicher Registrierung können Sie Verified by GS1 im Rahmen einer kostenfreien Testphase uneingeschränkt nutzen. Wir behalten uns das Recht vor, den Service in Zukunft kostenpflichtig anzubieten. Alle Änderungen werden wir Ihnen rechtzeitig mitteilen.
              </li>
              <li>
                <strong>Verfügbarkeit</strong>
                <ol>
                  <li>Anpassungen, Änderungen und Ergänzungen der vertragsgegenständlichen Leistungen sowie Maßnahmen,
                    die der Feststellung und Behebung von Funktionsstörungen dienen, werden nur dann zu einer
                    vorübergehenden Unterbrechung oder Beeinträchtigung der Erreichbarkeit führen, wenn dies aus
                    technischen Gründen zwingend notwendig ist.
                  </li>
                  <li>Der Anbieter strebt eine Verfügbarkeit der Anwendung von 98,5% im Jahresmittel an. Geplante und
                    angekündigte Wartungsarbeiten gelten nicht als Ausfallzeiten. Der Anbieter wird sich bemühen,
                    Wartungsarbeiten mindestens 7 Tage vor deren Beginn anzukündigen.
                  </li>
                </ol>
              </li>
              <li>
                <strong>Höhere Gewalt</strong>
                <ol>
                  <li>Der Anbieter ist von der Verpflichtung zur Leistung aus diesem Vertrag befreit, soweit die
                    Nichterfüllung von Leistungen auf das Eintreten von Umständen höherer Gewalt nach Vertragsabschluss
                    zurückzuführen ist.
                  </li>
                  <li>Als Umstände höherer Gewalt gelten zum Beispiel Krieg, Streiks, Unruhen, Pandemien, Enteignungen,
                    kardinale Rechtsänderungen, Sturm, Überschwemmungen und sonstige Naturkatastrophen sowie sonstige
                    von Anbieter nicht zu vertretende Umstände, insbesondere Wassereinbrüche, Stromausfälle,
                    Unterbrechungen oder Zerstörung datenführender Leitungen oder Infrastruktur sowie Hackerangriffe,
                    die auch mit branchenüblichen Sicherungsmaßnahmen nicht vermeidbar waren.
                  </li>
                  <li>Jede Vertragspartei hat die andere Vertragspartei über den Eintritt eines Falles von höherer
                    Gewalt unverzüglich schriftlich in Kenntnis zu setzen.
                  </li>
                </ol>
              </li>
              <li>
                <strong>Haftungsbeschränkung</strong>
                <ol>
                  <li>Der Anbieter haftet für Vorsatz und grobe Fahrlässigkeit uneingeschränkt, für leichte
                    Fahrlässigkeit jedoch nur bei der Verletzung vertragswesentlicher Pflichten. Als vertragswesentliche
                    Pflichten gelten solche Pflichten, deren Erfüllung die ordnungsgemäße Vertragsdurchführung erst
                    ermöglicht und auf deren Einhaltung der Vertragspartner vertraut und auch vertrauen darf. Die
                    Haftung bei Verletzung einer solchen vertragswesentlichen Pflicht ist auf den vertragstypischen
                    Schaden begrenzt, mit dessen Entstehen Anbieter bei Vertragsabschluss aufgrund der zu diesem
                    Zeitpunkt bekannten Umstände rechnen musste.
                  </li>
                  <li>Die vorstehenden Haftungsausschlüsse gelten nicht bei Verletzung von Leben, Körper und Gesundheit.
                    Die Haftung nach dem Produkthaftungsgesetz bleibt unberührt.
                  </li>
                  <li>Für vom Anbieter nicht verschuldete Störungen innerhalb des Leitungsnetzes übernimmt der Anbieter
                    keine Haftung.
                  </li>
                  <li>Für den Verlust von Daten haftet der Anbieter nach Maßgabe der vorstehenden Absätze nur dann, wenn
                    ein solcher Verlust durch angemessene Datensicherungsmaßnahmen seitens des Nutzers nicht vermeidbar
                    gewesen wäre.
                  </li>
                  <li>Der Anbieter haftet nicht für Beeinträchtigungen, die durch eine unsachgemäße oder fehlerhafte
                    Inanspruchnahme durch den Nutzer verursacht worden sind.
                  </li>
                  <li>Die vorstehenden Haftungsbeschränkungen gelten sinngemäß auch zugunsten der Erfüllungsgehilfen des
                    Anbieters.
                  </li>
                  <li>Soweit über die Anwendung eine Möglichkeit der Weiterleitung auf Datenbanken, Websites,
                    Schnittstellen oder Dienste Dritter, z. B. durch die Einstellung von Links oder Hyperlinks gegeben
                    ist, haftet der Anbieter weder für Zugänglichkeit, Bestand oder Sicherheit dieser Datenbanken oder
                    Dienste, noch für den Inhalt derselben. Insbesondere haftet der Anbieter nicht für deren
                    Rechtmäßigkeit, inhaltliche Richtigkeit, Vollständigkeit, Aktualität.
                  </li>
                </ol>
              </li>
              <li>
                <strong>Datenschutz</strong><br>
                Alle Informationen zur Verarbeitung personenbezogener Daten kann der Nutzer der Datenschutzerklärung vom
                Anbieter entnehmen. Diese ist unter <a
                  href='https://www.gs1-germany.de/datenschutz/'>Datenschutzinformationen</a>.
              </li>
              <li>
                <strong>Vertragsdauer, Kündigung</strong>
                <ol>
                  <li>Die Laufzeit des Vertrages sowie die Kündigungsfristen ergeben sich aus der jeweiligen
                    Produktbeschreibung, abrufbar unter <a
                      href='https://www.gs1-germany.de/fileadmin/gs1/agb/GS1_Germany_Leistungsbeschreibung_VbGS1_.pdf'>Produktbeschreibung</a>.
                  </li>
                  <li>Mit Beendigung des Vertrages hat der Nutzer keinen Zugriff mehr auf die unter diesem Vertrag
                    vereinbarten Leistungen.
                  </li>
                  <li>
                    Das Recht der Parteien zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt. Ein
                    wichtiger Grund für eine außerordentliche Kündigung liegt insbesondere vor, wenn
                    <ul>
                      <li>eine Partei wiederholt gegen vertragswesentliche Pflichten aus diesem Vertrag trotz Abmahnung
                        verstößt;
                      </li>
                      <li>eine Partei im Zusammenhang mit diesem Vertrag eine deliktische Handlung begeht;</li>
                      <li>eine der Parteien den Geschäftsbetrieb ganz oder teilweise einstellt, und der Weiterbetrieb
                        nicht durch einen unmittelbaren Rechtsnachfolger gesichert ist.
                      </li>
                    </ul>
                  </li>
                  <li>Die Kündigung hat in Textform zu erfolgen. Eine E-Mail ist ausreichend.</li>
                  <li>Mit der Beendigung des Vertrages, gleich aus welchem Grund, enden die vertraglichen
                    Nutzungsbefugnisse des Nutzers.
                  </li>
                </ol>
              </li>
              <li>
                <strong>Sonstiges, Schlussbestimmungen</strong>
                <ol>
                  <li>Es gilt das Recht der Bundesrepublik Deutschland. Für Streitigkeiten aus diesem Vertrag ist
                    ausschließlicher Gerichtsstand Köln.
                  </li>
                  <li>Die Vertragssprache ist deutsch. Sollten Übersetzungen des Vertrages der deutschen Fassung
                    widersprechen, hat diese stets Vorrang.
                  </li>
                  <li>Mündliche Nebenabreden sind nicht getroffen. Änderungen dieses Vertrages haben nur Gültigkeit,
                    wenn sie zwischen den Vertragsparteien schriftlich vereinbart werden. Dies gilt auch für die
                    Änderung der Schriftformklausel selbst.
                  </li>
                  <li>Sollte eine Bestimmung dieses Vertrages unwirksam sein oder werden, so berührt dies die
                    Wirksamkeit des Vertrages im Übrigen nicht.
                  </li>
                  <li>Der Nutzer verzichtet auf die Erfüllung der Pflichten im elektronischen Geschäftsverkehr nach §
                    312 i Abs. 1 Satz 1 Nr. 1 – 3 und Satz 2 BGB.
                  </li>
                </ol>
              </li>
            </ol>
          </template>
        </div>
      </div>
    </div>
    <div v-if='showButtons' class='row text-center'>
      <div class='col-xs-6'>
        <a role='button' class='btn btn-primary btn-margin' @click.prevent='accept'>{{ $t('accept') }}</a>
      </div>
      <div class='col-xs-6'>
        <a href='https://www.gs1-germany.de/' role='button' class='btn btn-secondary btn-margin'>{{ $t('decline') }}</a>
      </div>
    </div>
    <br>
    <gs1-alert v-if='errorState.length !== 0'>{{ errorState }}</gs1-alert>
  </div>
</template>

<script>
import Gs1Alert from '../../components/alerts/Gs1Alert.vue'
import {termsOfUseAccepted, acceptTermsOfUse} from '../../agb'

export default {
  components: { Gs1Alert },
  data() {
    return {
      currentAgbVersion: 'v1',
      errorState: ''
    }
  },
  computed: {
    showButtons() {
      return !termsOfUseAccepted()
    }
  },
  methods: {
    accept() {
      acceptTermsOfUse(() => {
        this.$router.push({ name: 'Start' })
      }, (errorMsg) => {
        this.errorState = errorMsg
      }
      )
    }
  },
  i18n: {
    messages: {
      de: {
        title: 'Nutzungsbedingungen „Verified by GS1“',
        accept: 'Akzeptieren',
        decline: 'Ablehnen',
        invalidAGB: 'Die Version der Nutzungsbedingungen ist uns nicht bekannt'
      },
      en: {
        title: 'Terms of Use for Verified by GS1',
        accept: 'Accept',
        decline: 'Decline',
        invalidAGB: 'Terms of use version is unknown'
      }
    }
  }
}
</script>

<style scoped>
h1 {
  word-wrap: break-word;
}

.toolkit .pre-scrollable {
  min-height: 400px;
  max-height: calc(100vh - 700px);
}

.toolkit ol>li {
  margin-bottom: 1.5em;
}

.toolkit ol>li>ol {
  list-style-type: lower-alpha;
  margin-top: .5em;
}

.toolkit ol>li>ol>li {
  margin-bottom: 0;
}

.toolkit a.btn {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/router/views/TermsOfUse.vue